import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mib-barchart-icon]',
  template: `
    <svg:path
      d="M7.33301 0C8.43636 0 9.33291 0.892408 9.33301 1.99805V5.33301H11.333C12.4375 5.33301 13.3328 6.22859 13.333 7.33301V11C13.333 12.2887 12.2887 13.333 11 13.333H2.33301C1.04449 13.3328 5.15362e-07 12.2886 0 11V6C0 4.89543 0.895431 4 2 4H4V2C4 0.895154 4.89571 0 6 0H7.33301ZM2 5.33301C1.63181 5.33301 1.33301 5.63181 1.33301 6V11C1.33301 11.5522 1.78087 11.9998 2.33301 12H4V5.33301H2ZM6 1.33301C5.63153 1.33301 5.33301 1.63209 5.33301 2V12H8V1.99805C7.9999 1.63109 7.70229 1.33301 7.33301 1.33301H6ZM9.33301 12H11C11.5523 12 12 11.5523 12 11V7.33301C11.9998 6.96497 11.7011 6.66699 11.333 6.66699H9.33301V12Z" />
  `,
  host: {
    '[attr.viewBox]': 'viewBox()',
    class: 'mib-icon-default-size fill-current transition-colors',
    '[class]': 'extraClass()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BarchartIcon {
  readonly viewBox = input<string>('0 0 16 16');
  readonly extraClass = input<string>('');
}
